<app-smart-table-with-badge
  [value]="versionBadge"
  (click)="openSwitchConfirmationPopup()"
  nbTooltip="We understand you might need to access some features in the old Facets. You can switch back anytime, but please note that all new features will be added in New UI."
  style="font-size: 16px"
></app-smart-table-with-badge>

<ng-template #versionSwitchConfirmation let-data let-ref="dialogRef">
  <nb-card style="width: 35vw">
    <nb-card-header>Switching to Old UI</nb-card-header>
    <nb-card-body class="pb-0">
      <p>
        You're switching back to the previous version of Facets. All new
        features will be launched in 2.0 only. Hence, we recommend you to use
        Facets 2.0 and let us know your feedback.
      </p>
    </nb-card-body>
    <nb-card-footer>
      <button
        nbButton
        size="small"
        status="primary"
        class="cc-margin-right"
        [nbSpinner]="loading"
        (click)="switchV1()"
      >
        Confirm
      </button>
      <button
        nbButton
        size="small"
        status="basic"
        (click)="onClickHandleCancel(ref)"
        class="cc-margin-right"
      >
        Cancel
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
